<template>
  <div>
    <h2>Completed Reviews</h2>

    <v-card class="pa-3 mt-2">
      <v-text-field
        outlined
        hide-details
        v-model="search"
        label="Search your reviews"
        prepend-inner-icon="mdi-note-search"
      ></v-text-field>
    </v-card>

    <v-data-table
      :search="search"
      :headers="headers"
      :items="reviews"
      :items-per-page="10"
      class="elevation-1 mt-5"
      show-expand
      item-key="_id"
      :single-expand="true"
    >
      <template v-slot:item="{ item, expand, isExpanded }">
        <tr>
          <td>
            <small slot="item.createdAt">{{
              formatDate(item.createdAt)
            }}</small>
          </td>
          <td slot="item.recommendation">
            {{ formatFolderId(item.recommendation) }}
          </td>
          <td slot="item.manuscript.folder">
            {{ formatFolderId(item.manuscript.folder) }}
          </td>
          <td slot="item.manuscript.title">
            {{ item.manuscript.title }}
          </td>
          <td>
            <v-btn
              slot="item.data-table-expand"
              small
              outlined
              color="orange darken-2"
              class="my-1 mr-1"
              @click="expand(!isExpanded)"
            >
              Read your review
            </v-btn>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers, item }" class="elevation-1">
        <td :colspan="headers.length" class="orange lighten-5">
          <div class="my-5 mx-auto" style="max-width: 760px">
            <strong class="mb-3"><u>Your review:</u></strong>
            <article v-html="item.review"></article>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatDate, formatFolderId } from "../../tools/format";

export default {
  data: () => ({
    search: "",
    loading: false,
    deleting: false,
    reviews: [],
    expanded: [],
    headers: [
      { text: "Written on", value: "createdAt" },
      { text: "Recommendation", value: "recommendation" },
      { text: "Manuscript ID", value: "manuscript.folder" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "manuscript.title",
      },
      {
        text: "Action",
        value: "data-table-expand",
        sortable: false,
      },
    ],
  }),
  methods: {
    formatDate,
    formatFolderId,
    fetchReviews() {
      this.loading = true;
      this.$axios
        .get("/reviews")
        .then(({ data: response }) => {
          this.reviews = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve reviews",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchReviews();
  },
};
</script>

<style lang="scss" >
.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgb(50 50 50 / 75%),
    inset 0px -4px 8px -5px rgb(50 50 50 / 75%);
  box-shadow: none !important;
  background-color: rgb(244, 245, 235);
}
</style>